function isCancelledNetworkError(error: Error) {
  return error.name === 'TypeError' && error.message === 'cancelled';
}

function isLoadFailed(error: Error) {
  // When we get a load or fetch error we retry.
  // If it happens again, we ignore the error.
  return (
    error.name === 'TypeError' &&
    (error.message === 'Failed to fetch' || error.message === 'Load failed')
  );
}

function isBrowserExtensionError(error: Error) {
  // The extension may be trying to send a message to a closed or invalid tab.
  return error.message?.includes(
    'Invalid call to runtime.sendMessage(). Tab not found.'
  );
}

export function isFilteredException(error: Error) {
  return (
    isCancelledNetworkError(error) ||
    isLoadFailed(error) ||
    isBrowserExtensionError(error)
  );
}
